import React, { useState, useContext, useEffect } from 'react';
import { connect } from 'react-redux'
import useWidth from '../../hooks/useWidth'
import Container from '../../layouts/Container/Container'
import Button from '../atoms/Button';
import { StateController } from './../../App'
import { stGoal } from '../../utils/helpers';
import Preloader from '../atoms/Preloader';
import { getPrice, sendDataLayer } from '../../utils/functions';
import CustomModal from '../molecules/CustomModal';
import VideoModal from '../molecules/VideoModal';

function Selector(token) {
    const { width } = useWidth();
    const [optionIndex, setOptionIndex] = useState(null);
    const {context} = useContext(StateController)
    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [showVideo, setShowVideo] = useState(false)
    const [selectedOptions, setSelectedOptions] = useState(['', '', '']);
    const [options, setOptions] = useState([
        {  
            title: 'El calculador',
            image: '/assets/images/metas_calculador.png',
            desc: 'Con estrategia, cada compra es una jugada bien pensada.',
            amount: 'XXX.XXX',
            trx: 'X',
            award: 'XX.XXX',
            options : []
        },
        {
            title: 'El visionario',
            image: '/assets/images/metas_visionario.png',
            desc: 'Compras y sumas con visión. Cada paso te acerca más.',
            amount: 'XXX.XXX',
            trx: 'X',
            award: 'XX.XXX',
            options : []
        },
        { 
            title: 'El imparable',
            image: '/assets/images/metas_imparable.png',
            desc: 'No lo piensas dos veces:  compras, sumas y avanzas.',
            amount: 'XXX.XXX',
            trx: 'X',
            award: 'XX.XXX',
            options : []
        }
    ]);

    const handleOptionClick = (idx) => {
        setOptionIndex(idx);
    }

    console.log("context", context)
    console.log("selectedOptions", selectedOptions)

    console.log("optionIndex", optionIndex, options)

    useEffect(() => {
        if (
            context.user &&
            context.user.unstoppable_amount_option &&
            context.user.calculating_trx_option &&
            context.user.calculating_amount_option &&
            context.user.unstoppable_trx_option &&
            context.user.calculating_award_option &&
            context.user.unstoppable_award_option
        ) {
            const calculatingKey = `s${(context.user.calculating_award_option/1000)}`;
            const unstoppableKey = `s${(context.user.unstoppable_award_option/1000)}`;
            const visionaryKey = `s${(context.user.visionary_award_option/1000)}`;

            const calculatingOptions = (context.denominations[calculatingKey] || [])
            .filter(item => item.name !== 'Falabella')
            .map(item => item.name);

            const unstoppableOptions = (context.denominations[unstoppableKey] || [])
            .filter(item => item.name !== 'Falabella')
            .map(item => item.name);

            const visionaryOptions = (context.denominations[visionaryKey] || [])
            .filter(item => item.name !== 'Falabella')
            .map(item => item.name);

            setOptions([
                {
                    ...options[0],
                    amount: context.user.calculating_amount_option,
                    trx: context.user.calculating_trx_option,
                    award: context.user.calculating_award_option,
                    options: calculatingOptions
                },
                {
                    ...options[1],
                    amount: context.user.visionary_amount_option,
                    trx: context.user.visionary_trx_option,
                    award: context.user.visionary_award_option,
                    options: visionaryOptions
                },
                {
                    ...options[2],
                    amount: context.user.unstoppable_amount_option,
                    trx: context.user.unstoppable_trx_option,
                    award: context.user.unstoppable_award_option,
                    options: unstoppableOptions
                }
            ]);
        }

        if(context.firstTime) {
            setShowVideo(true)
        }
    }, [context]);

    const handleGoal = () => {
        setIsLoading(true)
        sendDataLayer({datalayer: {event: "select_win", text_title: options[optionIndex].title, objective_selected: options[optionIndex].title, product_name:selectedOptions[optionIndex], product_price: options[optionIndex].award, goal_amount: options[optionIndex].amount, goal_transactions: options[optionIndex].trx}, repeat: true});
        stGoal(token.token, options[optionIndex].amount, options[optionIndex].trx, options[optionIndex].award, selectedOptions[optionIndex]).then((res) => {

            console.log("res", res)


            if (res && res.statusCode === 200) {
                window.location.href = '/progreso'
            }
            setIsLoading(false)
        }).catch(() => {
            setIsLoading(true)
        })
    }

    const handleModal = () => {
        if(!showModal){
            sendDataLayer({datalayer: {event: "prize_interest", text_title: options[optionIndex].title, product_name:selectedOptions[optionIndex], product_price: options[optionIndex].award, goal_amount: options[optionIndex].amount, goal_transactions: options[optionIndex].trx}, repeat: true});
        } else {
            sendDataLayer({datalayer: {event: "cancel_win", text_title: options[optionIndex].title, product_name:selectedOptions[optionIndex], product_price: options[optionIndex].award, goal_amount: options[optionIndex].amount, goal_transactions: options[optionIndex].trx}, repeat: true});
        }
        
        setShowModal(!showModal)
    }

    return (
        <div className='mc-page selector slow_ani'>
            <div className='banner'>
                <div className="reward-banner">
                  <span className="corner-square"></span>
                  <h1 className='blue'><strong>¡Ya estás inscrito!</strong><br/>Elige tu meta y rómpela</h1>
                </div>
            </div>
            {/* {width > 992 
                ?<img src='/assets/images/confeti_izq.png' className='confeti_izq' alt='confeti_izq'/>
                :<img src='/assets/images/confeti_izq_mb_sel.png' className='confeti_izq' alt='confeti_izq'/>
            } */}
            {context
            ?<>
                <Container>
                {width > 992
                ? <p className='select-title'>Selecciona la meta que mejor se ajuste a tu objetivo de facturación y compras:</p>
                : <p className='select-title'>Selecciona la meta que mejor se ajuste<br/>a tu objetivo de facturación y<br/>compras:</p>
                }
                <div className='options'>
                    {options.map((step, index) => {   
                        console.log("options", options)
                        return (
                            <div key={index} className={`options--item ${optionIndex === index ? 'active' : ''}`}
                                onClick={() => handleOptionClick(index)}>
                                <img src={step.image} alt={step.image} />
                                <h6>
                                    {step.title}
                                </h6>
                                <p dangerouslySetInnerHTML={{ __html: step.desc}} />
                                <div className='amount_trx'>
                                    <p>
                                        Meta de facturación: <strong> {getPrice(step.amount ? step.amount : 0)}</strong>
                                    </p>
                                    <p>
                                        Meta de compras: <strong> {step.trx}</strong>
                                    </p>
                                </div>
                                <p className='award-text'>
                                    Bono por {getPrice(step.award ? step.award : 0)}
                                </p>
                                <p className='select-text'>
                                    Selecciona el comercio donde redimirás tu bono.
                                </p>
                                <select
                                    className={`custom-select ${selectedOptions[index] !== "" ? 'active' : ''}`}
                                    value={selectedOptions[index]}
                                    onChange={e => {
                                        const newSelected = [...selectedOptions];
                                        // Reiniciar todos los selects a vacío ("")
                                        newSelected.fill("");
                                        // Asignar la nueva selección solo al select actual
                                        newSelected[index] = e.target.value;
                                        setSelectedOptions(newSelected);
                                    }}
                                >
                                    <option value="" disabled>
                                        Despliega la lista y elige un comercio
                                    </option>
                                    {step.options.map((name, idx) => (
                                        <option key={idx} value={name}>{name}</option>
                                    ))}
                                </select>
                            </div>
                        )  
                    })}
                </div>
                <Button
                    type="secondary"
                    text='Da el siguiente paso'
                    loading={isLoading}
                    status={(optionIndex !== null) && (selectedOptions[optionIndex] !== '') ? "active" : "inactive"}
                    onClick={handleModal}
                    icon={(optionIndex !== null) && (selectedOptions[optionIndex] !== '') ? 'flecha-der' : 'flecha-der-gray'}
                />
                <div className="cards-container-with-lines">
                    <img src="/assets/images/tarjetas.png" alt="tarjetasBogota"/>
                </div>
                <div className='mc-login__majorAward'>
                    <div className='majorAward-info'>
                        <p>Cumple tu meta</p>
                        <div className="reward-banner">
                        <span className="corner-square"></span>
                        <p className='blue'>y podrás ganar bonos <br/>y un viaje todo incluido.</p>
                        </div>
                    </div>
                </div>
                </Container>
                {/* {width > 992 
                ?<img src='/assets/images/confeti_der.png' className='confeti_der' alt='confeti_der'/>
                :<img src='/assets/images/confeti_izq_sel.png' className='confeti_der' alt='confeti_der'/>
                } */}
                </>
            :   <Preloader
                    type="section"
                    invert
                />
            }
            {showModal && (
                <CustomModal
                    title={`Una vez confirmes,<br/> no podrás cambiar tu meta`}
                    desc={
                        "Sin presión, solo asegúrate de que es la que mejor se ajusta a ti."
                    }
                    image="estrella.png"
                    show={showModal}
                    setShowModal={setShowModal}
                    primaryAction={
                        {
                            action: handleGoal,
                            buttonText: "Confirma tu meta",
                            loading: isLoading
                        }
                    }
                    secondaryAction={
                        {
                            action: handleModal,
                            buttonText: "Cambia tu elección"
                        }
                    }
                    datalayer= {{event: "cancel_win", text_title: options[optionIndex].title, product_name:selectedOptions[optionIndex], product_price: options[optionIndex].award, goal_amount: options[optionIndex].amount, goal_transactions: options[optionIndex].trx}}
                />
            )}

            {showVideo && (
                <VideoModal
                    show={showVideo}
                    setShowModal={setShowVideo}
                />
            )}
        </div>
    )
}

const mapState = ({ user: {token} }) => {
    return {
      token
    }
}
  
export default connect(mapState, {}) (Selector)